import { XCircle } from "@untitled-ui/icons-react";
import { getSkipReasonLabel } from "../hooks/useSkipDialog";

interface SkippedBannerProps {
	skipReason: string | null;
}

export const SkippedBanner: React.FC<SkippedBannerProps> = ({ skipReason }) => {
	return (
		<div className="bg-orange-50 border-l-4 border-orange-400 p-4 mb-4">
			<div className="flex items-center">
				<div className="flex-shrink-0">
					<XCircle className="h-5 w-5 text-orange-400" />
				</div>
				<div className="ml-3">
					<p className="text-sm text-orange-700 font-medium">
						Classé sans suite
					</p>
					<p className="text-sm text-orange-600 mt-1">
						Raison : {getSkipReasonLabel(skipReason || "")}
					</p>
				</div>
			</div>
		</div>
	);
};
